import axios from "axios";
import authHeader from "./auth-header";
import config from "../config";

class AccessRequestService {
    submitRequest(name, email, reason, username, password, fundPassword) {
        // Use correct config - either config.api.accessRequest or config.api.baseURL
        return axios.post(config.api.accessRequest, {
            name,
            email,
            reason,
            username,
            password,
            fundPassword
        });
    }

    getAllRequests() {
        // Should call: /api/admin/access-requests
        return axios.get(`${config.api.admin}/access-requests`, { 
            headers: authHeader() 
        });
    }

    updateRequestStatus(id, status) {
        // Should call: /api/admin/access-requests/:id
        return axios.patch(`${config.api.admin}/access-requests/${id}`, {
            status
        }, { 
            headers: authHeader() 
        });
    }
}

export default new AccessRequestService();
